import React from "react";
import { Controller } from "react-hook-form";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText
} from "@mui/material";

const ControlledRadioButtonsGroup = ({
  name,
  control,
  label,
  rules,
  errors,
  options = []
}) => (
  <FormControl component="fieldset" error={!!errors[name]}>
    <FormLabel component="legend">{label}</FormLabel>
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <RadioGroup {...field} row>
          {options.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio />}
              label={option.label}
            />
          ))}
        </RadioGroup>
      )}
    />
    {errors[name] && <FormHelperText>{errors[name].message}</FormHelperText>}
  </FormControl>
);

export default ControlledRadioButtonsGroup;
